import { css } from "@emotion/react";
import { transferToNative } from "@src/lib/WebAppBridge";
import React, { useEffect, useRef, useState } from "react";
import backArrow from "@src/assets/ico_arrow_back.png";
import Title from "@src/components/title/Title";
import { Common } from "@src/styles/Common";
import useCallToken from "@src/hooks/useCallToken";
import box from "../../assets/charginUseBox.png";
import Lottie from "lottie-react";
import loading from "../../assets/Loading.json";
import { getCancelRefundItemList, useRefundTicket } from "@src/hooks/advertisement/useAdvertisment";
import { ToastType } from "../deungi/DeungiTicketCancelList";
import useInfiniteScroll from "react-infinite-scroll-hook";
import ConfirmModal from "@src/components/popup/ConfirmModal";
import CancelModal from "./CancelModal";
import TicketCancelItem from "../deungi/TicketCancelItem";

const AdvertisementCancelRefund = () => {
    const [styleHeight, setStyleHeight] = useState<number>(318);
    const guideTextRef = useRef<any>(null);
    const { token } = useCallToken();
    const [isModalShow, setIsModalShow] = useState<boolean>(false);
    const [refundId, setRefundId] = useState<number>(0);
    const [toast, setToast] = useState<ToastType>({ showToast: false, toastMessage: "" });
    const [isStoreModalShow, setIsStoreModalShow] = useState<boolean>(false);
    const [isNotPossibleModalShow, setIsNotPossibleModalShow] = useState<boolean>(false);
    useEffect(() => {
        if (token) {
            setStyleHeight(guideTextRef.current?.offsetHeight + 56);
        }
    }, [token]);

    const { data, refetch, isLoading, hasNextPage, fetchNextPage } = getCancelRefundItemList({ page: 1, limit: 20, type: 1 }, 3);

    useEffect(() => {
        refetch();
    }, []);

    const [sentryRef] = useInfiniteScroll({
        loading: false,
        hasNextPage: Boolean(hasNextPage),
        onLoadMore: fetchNextPage,
        disabled: false,
        rootMargin: "0px 0px 0px 0px",
        delayInMs: 1000,
    });
    useEffect(() => {
        if (toast.showToast) {
            setTimeout(() => setToast({ showToast: false, toastMessage: "" }), 2500);
        }
    }, [toast]);
    const StoreModal = (
        <div css={storeModal}>
            <div className="title">취소 불가</div>
            인앱 스토어 결제의 경우
            <br />
            취소/환불은 APP Store, Google Play 스토어 앱에서 가능합니다
        </div>
    );
    const NotPossibleModal = (
        <div css={storeModal}>
            <div className="title">취소 불가</div>
            열람권 패키지 일부를 사용하거나 구매한 지
            <br />
            7일이 지난 결제내역입니다
        </div>
    );

    const tryRefundTicket = useRefundTicket(
        (res) => {
            refetch();
            res?.payload?.errCode !== -1
                ? setToast({ showToast: true, toastMessage: "취소가 완료되었습니다" })
                : setToast({
                      showToast: true,
                      toastMessage: res?.data?.payload?.message ?? "오류가 발생하였습니다 다시 시도해주세요",
                  });
        },
        () => {
            setToast({ showToast: true, toastMessage: "오류가 발생하였습니다 다시 시도해주세요" });
        },
    );

    const onClickRefundTicket = () => {
        tryRefundTicket.mutate(refundId);
    };

    return (
        <>
            <div css={CancelRefundWrap}>
                <div css={TitleWrap}>
                    <div
                        className="backBtn"
                        onClick={() => {
                            transferToNative("done", "closeWebView");
                        }}
                    >
                        <img src={backArrow} alt="" />
                    </div>
                    <Title title="광고권 취소/환불하기" size="large" />
                </div>
                <div css={ContentsWrap}>
                    <div css={ItemListWrap(styleHeight)}>
                        {data?.pages !== null && data?.pages[0]?.list?.length ? (
                            data?.pages?.map((page: any, idx: number) =>
                                page?.list?.map((item: any, idx: string) => (
                                    <TicketCancelItem
                                        key={item + idx}
                                        item={item}
                                        setIsModalShow={setIsModalShow}
                                        setRefundId={setRefundId}
                                        setToast={setToast}
                                        setIsStoreModal={setIsStoreModalShow}
                                        setIsNotPossibleModalShow={setIsNotPossibleModalShow}
                                    />
                                )),
                            )
                        ) : isLoading ? (
                            <div css={lottieDiv}>
                                <div>
                                    <Lottie animationData={loading} />
                                </div>
                            </div>
                        ) : (
                            data?.pages !== null && (
                                <div css={emptyList(styleHeight)}>
                                    <img src={box} alt="" />
                                    <div>충전된 광고권이 없어요</div>
                                </div>
                            )
                        )}
                        <div className="observed" ref={sentryRef} />
                    </div>
                    {isModalShow && <CancelModal setIsModalShow={setIsModalShow} onClickRefundTicket={onClickRefundTicket} />}
                    {isStoreModalShow && (
                        <ConfirmModal
                            resultMessage={StoreModal}
                            buttonText="확인"
                            onConfirm={() => {
                                setIsStoreModalShow(false);
                            }}
                        />
                    )}
                    {isNotPossibleModalShow && (
                        <ConfirmModal
                            resultMessage={NotPossibleModal}
                            buttonText="확인"
                            onConfirm={() => {
                                setIsNotPossibleModalShow(false);
                            }}
                        />
                    )}

                    <div css={toastStyle(toast.showToast)}>{toast.toastMessage}</div>
                    <div css={GuideText} ref={guideTextRef}>
                        매물광고권 충전 환불/취소 안내
                        <br />
                        - 매물광고권은 사용하지 않은 경우에 한 해, 구매 후 7일 이내에 자주묻는질문에서 직접 구매 취소할 수
                        있습니다.
                        <br />- 구매 후 7일 이내임에도 {"‘내정보>고객센터>자주묻는질문>매물광고권 취소/환불하기’"}에{" "}
                        {"'취소 불가'"} 상태라면 다음 중 하나 이상의 경우에 해당합니다.
                        <br />
                        1) 광고권 패키지의 일부를 사용하여서 직접 환불이 불가능한 경우
                        <br />
                        2) Google Play 결제를 통해 구매한 경우
                        <br />
                        3) iOS APP Store 결제를 통해 구매한 경우
                        <br />- 위 경우에 해당하는 결제 건의 구매 취소를 희망할 경우, 열람권 유효 기간 내에 고객센터로 문의해
                        주세요.
                        <br />
                        - 단, iOS APP Store 결제로 구매한 광고권의 구매 취소는 APPLE 고객센터를 통해서만 가능합니다.
                        <br />
                        - Google Play 결제로 구매한 광고권 는 구매 후 48시간 이내에는 Google Play 고객센터를 통해, 48시간 이후에는
                        고객센터를 통해 구매 취소할 수 있습니다.
                        <br />
                        - 구매 취소나 환불 시에는 결제한 수단으로 환불됩니다.
                        <br />- 구독 혜택 등 무료로 지급된 광고권은 환불 대상에서 제외됩니다.
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdvertisementCancelRefund;

const CancelRefundWrap = css`
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    align-items: center;
    -ms-overflow-style: none;
    scrollbar-width: none;
`;

const TitleWrap = css`
    display: flex;
    justify-content: center;
    position: fixed;
    background: #ffffff;
    width: 100%;
    z-index: 22;
    padding: 14px;
    align-items: center;
    & > .backBtn {
        position: absolute;
        left: 14px;
        width: 10px;
        height: 17px;
        & > img {
            width: 100%;
            height: 100%;
        }
    }
    & > .title {
        font-weight: 700;
    }
`;

const GuideText = css`
    background-color: ${Common.colors.grey01};
    color: ${Common.colors.greyPrimary};
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    padding: 20px 14px;
    margin-top: 30px;
`;

const ContentsWrap = css`
    width: 100%;
    overflow-y: scroll;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    padding-top: 56px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    position: relative;
    ::-webkit-scrollbar {
        display: none;
    }
    & > .observed {
        height: 30px;
        width: 100%;
    }
`;

const ItemListWrap = (styleHeight: number) => css`
    min-height: ${`calc(calc(var(--vh, 1vh) * 100) - ${styleHeight}px)`};
`;

const lottieDiv = css`
    width: 100%;
    height: calc(calc(var(--vh, 1vh) * 100) - 222px);
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    & > div {
        width: 106px;
        height: 63px;

        background-color: white;
        & > div {
            width: 100%;
            height: 100%;
        }
    }
`;

const emptyList = (styleHeight: number) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    -ms-overflow-style: none;
    scrollbar-width: none;
    align-items: center;
    gap: 24px;
    height: ${styleHeight && `calc(calc(var(--vh, 1vh) * 100) - ${styleHeight}px)`};
    & > img {
        width: 125px;
        height: 84px;
    }
    & > div {
        color: ${Common.colors.normalTextColor};
        font-size: 17px;
        font-weight: 400;
    }
`;
const storeModal = css`
    width: 100%;
    text-align: center;
    line-height: 24px;
    ${Common.textStyle.body3_R14};
    & > .title {
        ${Common.textStyle.body2_R16};
        margin-bottom: 8px;
    }
`;

const toastStyle = (isShowToast: boolean) => css`
    width: calc(100vw - 14px);
    height: 40px;
    padding: 8px 14px;
    background-color: ${Common.colors.darkGrey03};
    color: #ffffff;
    opacity: ${isShowToast ? 0.7 : 0};
    display: flex;
    justify-content: flex-start;
    align-items: center;
    z-index: 50px;
    border-radius: 14px;
    position: absolute;
    bottom: 100px;
    transition: all 0.4s;
    font-size: 14px;
    font-weight: 400;
`;
